import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateInvoiceState } from "./types";

const initialState: CreateInvoiceState = {
    isCreateInvoiceModalOpen: false,
    onCreate: null
}

interface OpenCreateInvoiceModal {
    onCreate?: () => void
}

const createInvoiceSlice = createSlice({
    name: 'createInvoice',
    initialState,
    reducers: {
        openCreateInvoiceModal: (state, action: PayloadAction<OpenCreateInvoiceModal>) => {
            state.isCreateInvoiceModalOpen = true
            state.onCreate = action.payload.onCreate
        },
        closeCreateInvoiceModal: (state) => {
            state.isCreateInvoiceModalOpen = false
        }
    }
})

export default createInvoiceSlice.reducer
export const { openCreateInvoiceModal, closeCreateInvoiceModal } = createInvoiceSlice.actions